import React from 'react';
import { FiPlayCircle } from 'react-icons/fi';
import { VimeoWithSurvey } from '@/components/custom/vimeo-with-survey';

// Vídeo de boas-vindas/destaque em formato reels (vertical 9:16). Fonte: mural ativo
// (campo video-id): aceita ID numérico do Vimeo OU URL direta de vídeo (ex.: .mp4).
export function HomeReelsVideo({ videoId }) {
  const isVimeoId = videoId != null && /^\d+$/.test(String(videoId));
  return (
    <div className="mx-auto aspect-[9/16] w-full max-w-[360px] overflow-hidden rounded-2xl border border-solid border-neutral-100 bg-neutral-900 shadow-card">
      {videoId ? (
        isVimeoId ? (
          <VimeoWithSurvey videoId={videoId} />
        ) : (
          <video
            src={videoId}
            controls
            playsInline
            className="h-full w-full object-cover"
          />
        )
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-bright p-6 text-center">
          <FiPlayCircle
            className="h-12 w-12"
            style={{ color: 'var(--color-mission)' }}
          />
          <p className="mb-0 text-sm font-semibold text-primary-dark">Seu vídeo da semana chega em breve!</p>
        </div>
      )}
    </div>
  );
}
